import React from 'react'
import { useState } from 'react'
import UserNav from './UserNav';
import {Input,Button,Heading, Checkbox} from "@chakra-ui/react";

const UsersPage = () => {
  const [changePass,setChangePass ]= useState(false);
  const [showPass,setShowPass]=useState(false);
  return (
    <div>
     <UserNav />
     <br/>
      <Heading marginBottom={'10px'} >{'Users Page'}</Heading>
      <Input marginBottom={'5px'} width="100vh" type="text" placeholder='Name' /><br/>
      <Input marginBottom={'5px'} width="100vh" type="text" placeholder='Email' readOnly/><br/>
      <Button marginBottom={'10px'} onClick={()=>{setChangePass(!changePass)}}>Change password</Button>
      <div style={{
        display:changePass?"block":"none",
      }}><hr/><br/>
        <Input marginBottom={'5px'} width="100vh" type={showPass?"text":"password"} placeholder='old password' required /><br/>
        <Input marginBottom={'5px'} width="100vh" type={showPass?"text":"password"} placeholder='new password' required /><br/>
        <Input marginBottom={'5px'} width="100vh" type={showPass?"text":"password"} placeholder='new confirm password' required /><br/>
        <Checkbox marginBottom={'5px'} onChange={()=>{setShowPass(!showPass)}} >show password</Checkbox><br/>
        <Button>Change</Button>
      </div>
      <br/><hr/>
      <Button marginTop={'5px'}>Delete Account</Button>

    </div>
  )
}

export default UsersPage
